const baseURL = 'https://raw.githubusercontent.com/delfieuxalexi-afk/alexi-delfieux-portfolio/main/';

export const mockArtworks = [
  {
    id: 1,
    title: 'Saint Martin 01',
    series: 'saintMartin',
    year: 2021,
    size: '115x75 cm',
    medium: 'Acrylic on canvas',
    colors: ['Orange', 'Blue', 'Pink', 'Yellow'],
    price: 1200,
    available: true,
    image: baseURL + 'saintmartin01.jpg',
    description: {
      en: 'A large triangular form set against a gradient sky, evoking the geometric architecture of urban landscapes merged with natural horizons.',
      fr: 'Une grande forme triangulaire sur un ciel en dégradé, évoquant l\'architecture géométrique des paysages urbains fusionnée avec des horizons naturels.'
    }
  },
  {
    id: 2,
    title: 'MER Rouge',
    series: 'saintMartin',
    year: 2021,
    size: '115x75 cm',
    medium: 'Acrylic on canvas',
    colors: ['Red', 'Pink', 'Yellow', 'White'],
    price: 1200,
    available: true,
    image: baseURL + 'merrouge.jpg',
    description: {
      en: 'Vibrant red and pink tones evoke the intensity of sunset horizons, with geometric forms creating depth and movement.',
      fr: 'Des tons rouges et roses vibrants évoquent l\'intensité des horizons au coucher du soleil, avec des formes géométriques créant profondeur et mouvement.'
    }
  },
  {
    id: 3,
    title: 'Rivière Saint Martin 01',
    series: 'saintMartin',
    year: 2021,
    size: '115x75 cm',
    medium: 'Acrylic on canvas',
    colors: ['Turquoise', 'Green', 'Silver', 'Blue'],
    price: 1200,
    available: true,
    image: baseURL + 'rivieresaintmartin01.jpg',
    description: {
      en: 'Cool water tones blend with metallic textures, capturing the reflective quality of the Seine and canal systems.',
      fr: 'Des tons d\'eau frais se mélangent avec des textures métalliques, capturant la qualité réfléchissante de la Seine et des systèmes de canaux.'
    }
  },
  {
    id: 4,
    title: 'Bloody Town 01',
    series: 'saintMartin',
    year: 2021,
    size: '120x40 cm',
    medium: 'Acrylic on canvas',
    colors: ['Red', 'Blue', 'White'],
    price: 650,
    available: true,
    image: baseURL + 'bloodytown01.jpg',
    description: {
      en: 'A panoramic cityscape where dripping red forms suggest both urban decay and vitality.',
      fr: 'Un paysage urbain panoramique où des formes rouges dégoulinantes suggèrent à la fois décadence urbaine et vitalité.'
    }
  },
  {
    id: 5,
    title: 'Rainy City 01',
    series: 'saintMartin',
    year: 2021,
    size: '40x120 cm',
    medium: 'Acrylic on canvas',
    colors: ['Blue', 'Silver', 'Orange', 'Red'],
    price: 800,
    available: true,
    image: baseURL + 'rainycity01.jpg',
    description: {
      en: 'Vertical elements mimic rain falling on metallic urban surfaces, creating atmospheric depth.',
      fr: 'Des éléments verticaux imitent la pluie tombant sur des surfaces urbaines métalliques, créant une profondeur atmosphérique.'
    }
  },
  {
    id: 6,
    title: 'Zer Gate',
    series: 'saintMartin',
    year: 2019,
    size: '50x70 cm',
    medium: 'Acrylic on canvas',
    colors: ['Blue', 'Turquoise', 'Red'],
    price: 450,
    available: true,
    image: baseURL + 'zergate.jpg',
    description: {
      en: 'Layered horizontal bands with intricate patterns suggest architectural gateways and urban passages.',
      fr: 'Des bandes horizontales superposées avec des motifs complexes suggèrent des portails architecturaux et des passages urbains.'
    }
  },
  {
    id: 7,
    title: 'Rising',
    series: 'saintMartin',
    year: 2020,
    size: '29x29 cm',
    medium: 'Acrylic on 3D canvas',
    colors: ['Pink', 'Orange', 'Blue', 'White'],
    price: 300,
    available: true,
    image: baseURL + 'rising.jpg',
    description: {
      en: 'A circular sun or moon form rises over a stark horizon, blending natural and urban elements.',
      fr: 'Une forme circulaire de soleil ou de lune se lève sur un horizon austère, mêlant éléments naturels et urbains.'
    }
  },
  {
    id: 8,
    title: 'Rise in Saint Martin - 01',
    series: 'rise',
    year: 2021,
    size: '29x29 cm',
    medium: 'Acrylic on 3D canvas',
    colors: ['Orange', 'Yellow', 'Blue'],
    price: 300,
    available: true,
    image: baseURL + 'riseinsaintmartin-01m.jpg',
    description: {
      en: 'Square geometric forms emerge from textured blue, suggesting sunrise over water.',
      fr: 'Des formes géométriques carrées émergent du bleu texturé, suggérant le lever du soleil sur l\'eau.'
    }
  },
  {
    id: 9,
    title: 'Rise in Saint Martin - 02',
    series: 'rise',
    year: 2021,
    size: '29x29 cm',
    medium: 'Acrylic on 3D canvas',
    colors: ['Orange', 'Blue'],
    price: 350,
    available: true,
    image: baseURL + 'riseinsaintmartin-02m.jpg',
    description: {
      en: 'A diamond orientation creates dynamic tension between geometric shape and horizon line.',
      fr: 'Une orientation en diamant crée une tension dynamique entre forme géométrique et ligne d\'horizon.'
    }
  },
  {
    id: 10,
    title: 'RISE in Saint Martin - 01',
    series: 'rise',
    year: 2021,
    size: '50x50 cm',
    medium: 'Acrylic on 3D canvas',
    colors: ['Blue', 'Yellow', 'Orange', 'Pink'],
    price: 500,
    available: true,
    image: baseURL + 'riiseinsaintmartin-01s.jpg',
    description: {
      en: 'Large-scale diamond form against a vibrant gradient sky, capturing the essence of dawn.',
      fr: 'Forme en diamant à grande échelle sur un ciel en dégradé vibrant, capturant l\'essence de l\'aube.'
    }
  },
  {
    id: 11,
    title: 'RISE in Saint Martin - 02',
    series: 'rise',
    year: 2021,
    size: '50x50 cm',
    medium: 'Acrylic on 3D canvas',
    colors: ['Orange', 'Blue', 'Pink', 'Red'],
    price: 500,
    available: true,
    image: baseURL + 'riseinsaintmartin-02s.jpg',
    description: {
      en: 'Central orange square floats between sky and water, creating a meditative focal point.',
      fr: 'Un carré orange central flotte entre ciel et eau, créant un point focal méditatif.'
    }
  },
  {
    id: 12,
    title: 'RISE in Saint Martin - 03',
    series: 'rise',
    year: 2021,
    size: '50x50 cm',
    medium: 'Acrylic on 3D canvas',
    colors: ['Orange', 'Blue', 'Yellow', 'Pink'],
    price: 500,
    available: true,
    image: baseURL + 'riseinsaintmartin-03m.jpg',
    description: {
      en: 'Warm orange meets cool blue in a balanced composition exploring color temperature.',
      fr: 'L\'orange chaud rencontre le bleu frais dans une composition équilibrée explorant la température des couleurs.'
    }
  },
  {
    id: 13,
    title: 'Love Splash 01',
    series: 'rise',
    year: 2021,
    size: '29x29 cm',
    medium: 'Acrylic on 3D canvas',
    colors: ['Red', 'Blue'],
    price: 200,
    available: true,
    image: baseURL + 'lovesplash01.jpg',
    description: {
      en: 'Bold graffiti lettering meets dripping paint, echoing street art traditions.',
      fr: 'Des lettres graffiti audacieuses rencontrent de la peinture qui coule, faisant écho aux traditions de l\'art de rue.'
    }
  },
  {
    id: 14,
    title: 'Peace Throw 01',
    series: 'rise',
    year: 2021,
    size: '29x29 cm',
    medium: 'Acrylic on 3D canvas',
    colors: ['Pink', 'Blue', 'Black', 'Red'],
    price: 200,
    available: true,
    image: baseURL + 'peacethrow01.jpg',
    description: {
      en: 'Stylized graffiti text combines with atmospheric gradient, balancing message and aesthetics.',
      fr: 'Un texte graffiti stylisé se combine avec un dégradé atmosphérique, équilibrant message et esthétique.'
    }
  },
  {
    id: 15,
    title: 'Bloc 01',
    series: 'bloc',
    year: 2021,
    size: '40x50 cm',
    medium: 'Acrylic on canvas',
    colors: ['Orange', 'Yellow', 'Blue'],
    price: 350,
    available: true,
    image: baseURL + 'bloc01.jpg',
    description: {
      en: 'Geometric planes fold and intersect, creating architectural depth through color blocking.',
      fr: 'Des plans géométriques se plient et se croisent, créant une profondeur architecturale par blocs de couleur.'
    }
  },
  {
    id: 16,
    title: 'Bloc 02',
    series: 'bloc',
    year: 2021,
    size: '40x50 cm',
    medium: 'Acrylic on canvas',
    colors: ['Blue', 'Black', 'Orange'],
    price: 350,
    available: true,
    image: baseURL + 'bloc02.jpg',
    description: {
      en: 'Dark shadows meet vibrant surfaces, exploring light and structure in urban spaces.',
      fr: 'Des ombres sombres rencontrent des surfaces vibrantes, explorant lumière et structure dans les espaces urbains.'
    }
  },
  {
    id: 17,
    title: 'Bloc 03',
    series: 'bloc',
    year: 2021,
    size: '40x50 cm',
    medium: 'Acrylic on canvas',
    colors: ['Blue', 'Pink', 'Grey'],
    price: 350,
    available: true,
    image: baseURL + 'bloc03.jpg',
    description: {
      en: 'Soft color palette creates a gentler architectural study, balancing structure with emotion.',
      fr: 'Une palette de couleurs douces crée une étude architecturale plus douce, équilibrant structure et émotion.'
    }
  },
  {
    id: 18,
    title: 'Tilt 01',
    series: 'bloc',
    year: 2020,
    size: '29x29 cm',
    medium: 'Acrylic on 3D canvas',
    colors: ['Pink', 'Orange', 'Blue'],
    price: 300,
    available: true,
    image: baseURL + 'tilt01.jpg',
    description: {
      en: 'Tilted circular form disrupts the horizon, creating visual tension and movement.',
      fr: 'Une forme circulaire inclinée perturbe l\'horizon, créant tension visuelle et mouvement.'
    }
  },
  {
    id: 19,
    title: 'Tilt 02',
    series: 'bloc',
    year: 2020,
    size: '29x29 cm',
    medium: 'Acrylic on 3D canvas',
    colors: ['Pink', 'Orange', 'Blue'],
    price: 300,
    available: true,
    image: baseURL + 'tilt02.jpg',
    description: {
      en: 'Similar to Tilt 01 but with deeper blue tones, exploring variations on a theme.',
      fr: 'Similaire à Tilt 01 mais avec des tons bleus plus profonds, explorant des variations sur un thème.'
    }
  },
  {
    id: 20,
    title: 'Bayamère.01',
    series: 'bloc',
    year: 2020,
    size: '40x50 cm',
    medium: 'Acrylic on canvas',
    colors: ['Blue', 'Pink', 'Silver'],
    price: 400,
    available: true,
    image: baseURL + 'bayamere01.jpg',
    description: {
      en: 'Horizontal bands with metallic speckles evoke water reflections and urban light.',
      fr: 'Des bandes horizontales avec des paillettes métalliques évoquent les reflets de l\'eau et la lumière urbaine.'
    }
  },
  {
    id: 21,
    title: 'Prismozer 01',
    series: 'bloc',
    year: 2021,
    size: '115x75 cm',
    medium: 'Acrylic on canvas',
    colors: ['Red', 'Pink', 'Yellow', 'Blue'],
    price: 1200,
    available: true,
    image: baseURL + 'prismozer01.jpg',
    description: {
      en: 'Large-scale prismatic form captures light and color in an urban abstract language.',
      fr: 'Une forme prismatique à grande échelle capture lumière et couleur dans un langage abstrait urbain.'
    }
  },
  {
    id: 22,
    title: 'OZE',
    series: 'earlyMozer',
    year: 2018,
    size: '20x20 cm',
    medium: 'Mixed media on canvas board',
    colors: ['Red', 'Blue', 'White'],
    price: 250,
    available: true,
    image: baseURL + 'oze.jpg',
    description: {
      en: 'Early exploration of graffiti letterforms with bold color contrast.',
      fr: 'Exploration précoce de formes de lettres graffiti avec un contraste de couleurs audacieux.'
    }
  },
  {
    id: 23,
    title: 'Gold Jungle',
    series: 'earlyMozer',
    year: 2018,
    size: '20x20 cm',
    medium: 'Mixed media on canvas board',
    colors: ['Gold', 'Brown', 'Green'],
    price: 350,
    available: true,
    image: baseURL + 'goldjungle.jpg',
    description: {
      en: 'Natural elements collaged with urban textures, exploring material complexity.',
      fr: 'Éléments naturels collés avec des textures urbaines, explorant la complexité des matériaux.'
    }
  },
  {
    id: 24,
    title: 'Bloody music',
    series: 'earlyMozer',
    year: 2018,
    size: '20x20 cm',
    medium: 'Acrylic on canvas board',
    colors: ['Turquoise', 'Red'],
    price: 200,
    available: true,
    image: baseURL + 'bloodymusic.jpg',
    description: {
      en: 'Energetic splashes suggest rhythm and spontaneity, bridging visual and sonic art.',
      fr: 'Des éclaboussures énergétiques suggèrent rythme et spontanéité, reliant art visuel et sonore.'
    }
  },
  {
    id: 25,
    title: 'MozeR',
    series: 'earlyMozer',
    year: 2018,
    size: '120x40 cm',
    medium: 'Acrylic on canvas',
    colors: ['Blue', 'Red'],
    price: 1600,
    available: true,
    image: baseURL + 'mozer.jpg',
    description: {
      en: 'Large-scale graffiti tag establishes the artist\'s signature style and identity.',
      fr: 'Un tag graffiti à grande échelle établit le style signature et l\'identité de l\'artiste.'
    }
  },
  {
    id: 26,
    title: 'Mozmass',
    series: 'earlyMozer',
    year: 2019,
    size: '24x30 cm',
    medium: 'Acrylic on canvas board',
    colors: ['Pink', 'Blue', 'Green', 'Purple'],
    price: 200,
    available: true,
    image: baseURL + 'mozmass.jpg',
    description: {
      en: 'Dense layering of tags creates a vibrant, chaotic energy typical of street art.',
      fr: 'Une superposition dense de tags crée une énergie vibrante et chaotique typique de l\'art de rue.'
    }
  },
  {
    id: 27,
    title: 'MassMoz',
    series: 'earlyMozer',
    year: 2019,
    size: '25x25 cm',
    medium: 'Acrylic on canvas board',
    colors: ['White', 'Blue', 'Red', 'Orange'],
    price: 200,
    available: true,
    image: baseURL + 'massmoz.jpg',
    description: {
      en: 'Bold white lettering dominates against colorful drips, asserting presence.',
      fr: 'Des lettres blanches audacieuses dominent contre des gouttes colorées, affirmant une présence.'
    }
  },
  {
    id: 28,
    title: '3 Reckless Monkeys',
    series: 'earlyMozer',
    year: 2018,
    size: '3 x 20x20 cm',
    medium: 'Mixed media on wood',
    colors: ['Brown', 'Blue', 'Pink'],
    price: 360,
    available: true,
    image: baseURL + '3recklacemonkeys.jpg',
    description: {
      en: 'Triptych exploring expression and gesture through iconic three monkeys motif.',
      fr: 'Triptyque explorant expression et geste à travers le motif iconique des trois singes.'
    }
  },
  {
    id: 29,
    title: 'Dyptique Lionjah',
    series: 'earlyMozer',
    year: 2017,
    size: '2 x 20x30 cm',
    medium: 'Mixed media on wood',
    colors: ['Pink', 'Blue', 'Yellow', 'Orange'],
    price: 300,
    available: true,
    image: baseURL + 'lionjah.jpg',
    description: {
      en: 'Diptych merging human and animal, urban and natural, in a graffiti-infused style.',
      fr: 'Diptyque fusionnant humain et animal, urbain et naturel, dans un style imprégné de graffiti.'
    }
  },
  {
    id: 30,
    title: 'Mozer cave',
    series: 'origins',
    year: 2019,
    size: '50x50 cm',
    medium: 'Acrylic on canvas',
    colors: ['Pink', 'Blue', 'Green', 'Purple', 'Yellow'],
    price: 450,
    available: true,
    image: baseURL + 'mozercave.jpg',
    description: {
      en: 'Dense interior of overlapping letters suggests a cave of accumulated marks and memory.',
      fr: 'Intérieur dense de lettres qui se chevauchent suggère une grotte de marques accumulées et de mémoire.'
    }
  },
  {
    id: 31,
    title: 'Mère rouge',
    series: 'origins',
    year: 2019,
    size: '25x25 cm',
    medium: 'Acrylic on canvas board',
    colors: ['Red', 'Turquoise', 'White'],
    price: 220,
    available: true,
    image: baseURL + 'mererouge.jpg',
    description: {
      en: 'Geometric abstraction with totemic quality, suggesting ancestral forms.',
      fr: 'Abstraction géométrique avec qualité totémique, suggérant des formes ancestrales.'
    }
  },
  {
    id: 32,
    title: 'GLAMOZER',
    series: 'origins',
    year: 2019,
    size: '20x20 cm',
    medium: 'Acrylic on paper',
    colors: ['Pink', 'Blue', 'Green', 'Yellow'],
    price: 100,
    available: true,
    image: baseURL + 'glamozer.jpg',
    description: {
      en: 'Portrait merged with graffiti layers, exploring identity and representation.',
      fr: 'Portrait fusionné avec des couches de graffiti, explorant identité et représentation.'
    }
  },
  {
    id: 33,
    title: 'Mozerfull',
    series: 'origins',
    year: 2019,
    size: '24x30 cm',
    medium: 'Acrylic on canvas board',
    colors: ['Pink', 'Blue', 'Green', 'Purple', 'Yellow'],
    price: 250,
    available: true,
    image: baseURL + 'mozerfull.jpg',
    description: {
      en: 'Maximal density of color and form, celebrating abundance and creative energy.',
      fr: 'Densité maximale de couleur et de forme, célébrant abondance et énergie créative.'
    }
  },
  {
    id: 34,
    title: 'Mozerless',
    series: 'origins',
    year: 2019,
    size: '30x24 cm',
    medium: 'Acrylic on canvas board',
    colors: ['Black', 'Pink', 'Blue', 'Green'],
    price: 250,
    available: true,
    image: baseURL + 'mozerless.jpg',
    description: {
      en: 'Central void surrounded by vibrant marks explores absence and presence.',
      fr: 'Vide central entouré de marques vibrantes explore absence et présence.'
    }
  },
  {
    id: 35,
    title: 'Les origines de madame Claude(zer)',
    series: 'origins',
    year: 2019,
    size: '24x30 cm',
    medium: 'Acrylic on canvas board',
    colors: ['Red', 'Yellow', 'Pink', 'Blue'],
    price: 1000,
    available: true,
    image: baseURL + 'mmeclaudzer.jpg',
    description: {
      en: 'Totemic figure built from graffiti language, connecting personal and collective histories.',
      fr: 'Figure totémique construite à partir du langage graffiti, reliant histoires personnelles et collectives.'
    }
  },
  {
    id: 36,
    title: 'Selfmoz.1',
    series: 'origins',
    year: 2020,
    size: '24x30 cm',
    medium: 'Mixed media on canvas board',
    colors: ['Teal', 'Pink', 'Purple', 'Yellow'],
    price: 150,
    available: true,
    image: baseURL + 'selfmoz1.jpg',
    description: {
      en: 'Abstract self-portrait using graphic elements, exploring identity through shape and color.',
      fr: 'Autoportrait abstrait utilisant des éléments graphiques, explorant l\'identité à travers forme et couleur.'
    }
  }
];
